
import { pathOr, filter } from "ramda";
import { mapState } from "vuex";
import ClickOutside from "vue-click-outside";

const filterItems = filter(pathOr(false, ["targetVariantId"]));

export default {
  directives: { ClickOutside },

  props: {
    tiles: { type: Array, default: () => [] },
    selectedTile: { type: String, default: "" },
    variants: { type: Object, required: true },
    label: { type: String, default: "" },
  },

  data() {
    return {
      internalSelectedTile: this.selectedTile,
      active: false,
    };
  },

  computed: {
    ...mapState("pdp", ["variantLoading"]),
    bases() {
      return filterItems(this.tiles);
    },
  },

  watch: {
    selectedTile(value) {
      this.internalSelectedTile = value;
    },
  },

  methods: {
    getPrice(variantId) {
      return pathOr("", ["variants", variantId, "price"], this);
    },
    handleClick(tileLabel) {
      if (this.variantLoading) {
        return;
      }

      const tile = this.bases.find(element => element.tileLabel == tileLabel);

      this.$emit(
        "select-variant-id",
        tile.targetVariantId,
        this.label,
        tileLabel
      );
    },
    hide() {
      this.active = false;
    },
  },
};
